export default __webpack_public_path__ + "static/media/category_d.e101bcce.svg";